import React from 'react';
import { pricing } from '../data/content';
import { CtaButton } from './CtaButton';
import { TrustRow } from './TrustRow';
export function FinalCta() {
  return <section className="bg-cream py-20 sm:py-24" aria-labelledby="final-title" data-id="element-65" data-mp="vhiu1yaox88u">
      <div className="mx-auto max-w-[880px] px-5 text-center sm:px-8" data-id="element-66" data-mp="19ga51bu9adsr">
        <h2 id="final-title" className="text-balance font-display text-[2.2rem] leading-[1.06] text-petrol sm:text-5xl" data-id="element-67" data-mp="15capavgsvj0g">
          Tu próxima sesión no tiene que empezar <em className="text-terra" data-id="element-68" data-mp="1ee1zacidic04">desde una hoja en blanco.</em>
        </h2>
        <div className="mx-auto mt-8 max-w-2xl space-y-4 text-lg leading-relaxed text-ink-soft" data-id="element-69" data-mp="1ebxrhjhcssuk">
          <p data-id="element-70" data-mp="1t50ywy18dq7k">
            Podés seguir dedicando tiempo a buscar preguntas, organizar recursos y preparar estructuras desde cero. O
            podés tener una biblioteca organizada a la que acudir cuando necesitás un punto de partida.
          </p>
          <p data-id="element-71" data-mp="1x5b9knzyx4sr">
            6 módulos. Más de 300 páginas. Estructuras, preguntas, guiones orientativos, prompts, diálogos e intervenciones
            organizadas por temática.{' '}
            <strong className="font-semibold text-petrol" data-id="element-72" data-mp="s45t04tnbjva">Todo dentro de Megapack Maestro de Sesiones.</strong>
          </p>
        </div>

        <div className="mx-auto mt-10 w-fit rounded-2xl bg-paper px-10 py-6 shadow-soft ring-1 ring-cream-line" data-id="element-73" data-mp="x27boon5th68">
          <p className="font-display text-5xl text-petrol" data-id="element-74" data-mp="1246ik8i3yw7x">
            <span className="mr-2 text-2xl text-terra" data-id="element-75" data-mp="1658h0n47b48u">Hoy:</span>
            {pricing.today}
          </p>
          <p className="mt-1 text-sm text-ink-mute" data-id="element-76" data-mp="1b2i4vybxz7uk">Valor total: {pricing.totalValue}</p>
        </div>

        <div className="mt-8" data-id="element-77" data-mp="1fvbbysuvus9t">
          <CtaButton checkout block className="!px-4 !text-[13px] sm:!text-[15px]" data-id="element-78" data-mp="1fwcvzmtvmp3o">
            Quiero acceder a Maestro de Sesiones
          </CtaButton>
        </div>
        <p className="mt-4 text-sm text-ink-mute" data-id="element-79" data-mp="1ptr0co2iznfm">Pago único · Acceso inmediato · Acceso de por vida</p>
        <div className="mt-6" data-id="element-80" data-mp="1tuugzcsednhw">
          <TrustRow data-id="element-81" data-mp="1tryedb5luan4" />
        </div>
      </div>
    </section>;
}